import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { createPsAxiosInstance } from '@patsnap/common-ps-http';
import { inject, injectable } from 'inversify';
import { Symbols } from '../../../symbols';
import { format } from '@/@core/utils/string';
const ANALYTICS_URLS = {
    CI: 'https://ci-basic-service.zhihuiya.com',
    QA: 'https://qa-basic-service.zhihuiya.com',
};
let PromptManagementApi = class PromptManagementApi {
    constructor(http, urls, analyticsUrls) {
        this.http = http;
        this.urls = urls;
        this.analyticsUrls = analyticsUrls;
        this.analyticsHttp = createPsAxiosInstance().psHttp;
        this.normalizePrompt = (params) => {
            return {
                ...params,
                name: _.trim(params.name),
                prompt_key: _.trim(params.prompt_key),
                feature: _.trim(params.feature),
                content: _.mapValues(params.content, v => _.trim(v)),
            };
        };
        this.addPrompt = (params) => {
            return this.http.post({
                url: this.urls.addPrompt,
                data: this.normalizePrompt(params),
            });
        };
        this.updatePrompt = (params) => {
            return this.http.put({
                url: format(this.urls.updatePrompt, { id: params.id }),
                data: this.normalizePrompt(params),
            });
        };
        this.deletePrompt = (id) => {
            const url = format(this.urls.deletePrompt, { id });
            return this.http.delete({
                url,
            });
        };
        this.listPromptPagination = (params) => {
            const { sEcho, iDisplayStart, iDisplayLength, ...other } = params;
            return this.http.post({
                url: this.urls.listPromptPagination,
                params: {
                    sEcho,
                    iDisplayStart,
                    iDisplayLength,
                },
                data: other,
            });
        };
        this.keyGen = (product, feature, name, excludeName = '') => {
            return this.http.post({
                url: this.urls.keyGen,
                params: {
                    exclude: excludeName,
                },
                data: {
                    product,
                    feature,
                    name,
                },
            });
        };
        this.getPrompt = (id) => {
            const url = format(this.urls.getPrompt, { id });
            return this.http.get({
                url,
            });
        };
        this.publishLocalPrompt = (env, prompt) => {
            // 线上后端没法直接发布CI和QA环境，需要前端直接调对应环境的basic服务，但此步没法更新发布历史，需要后面再调发布接口
            if (!ANALYTICS_URLS[env]) {
                return Promise.resolve();
            }
            return this.analyticsHttp({
                method: 'post',
                headers: {
                    'X-Prompt-IDENTITY': 'AuqK3hJrPwslj2YVVQWhNQpNSm5VbXQPUfbYqiI8v7Lmi9pdgGZbhgCUPcvYHIYppVxQXmgK9X8uyLUNA1dL6hJXCHrmxPG9uL0RhQH5xZDUTNQEzX2hsQRFvnJevhg',
                },
                baseURL: ANALYTICS_URLS[env],
                url: this.analyticsUrls.publishPrompt,
                data: [_.pick(prompt, ['platforms', 'prompt_key', 'content'])],
            });
        };
        this.publishUpdatePrompt = (params) => {
            // 线上后端只能发布release/线上环境，CI/QA需要前端直接调对应环境的basic服务，再调此接口
            return this.http.post({
                url: this.urls.publishPrompt,
                data: params,
            });
        };
    }
};
PromptManagementApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.PromptManagementUrls)),
    __param(2, inject(Symbols.AnalyticsPromptUrls)),
    __metadata("design:paramtypes", [Object, Object, Object])
], PromptManagementApi);
export { PromptManagementApi };
